import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import CartSheet from "@/components/CartSheet";
import Home from "@/pages/Home";
import Kitchen from "@/pages/Kitchen";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import OrderConfirmed from "@/pages/OrderConfirmed";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/order/:orderId" element={<OrderConfirmed />} />
            <Route path="/kitchen" element={<Kitchen />} />
          </Routes>
          <CartSheet />
          <Toaster position="top-center" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
